import TourGuard from './TourGuard';
import IntroTourAutostart from '../IntroTourAutostart';

// Tour controllers that depend on the router (useLocation / useNavigate). Render
// this inside the BrowserRouter, alongside the app routes.
const TourRouteWatchers = () => (
	<>
		<TourGuard />
		<IntroTourAutostart />
	</>
);

export default TourRouteWatchers;
